import { StyledFileAsImage, StyledFileBox, StyledImageWrapper, StyledRemoveImageButton } from "./ChatInputBar.styled";

interface FileAsImageProps {
  file: File;
  onRemove: () => void;
}

const FileAsImage: React.FC<FileAsImageProps> = ({ file, onRemove }) => {
    return (
      <StyledFileBox>
        <StyledImageWrapper>
          <StyledRemoveImageButton onClick={onRemove}>×</StyledRemoveImageButton>
          <StyledFileAsImage 
            src={URL.createObjectURL(file)}
            alt="Selected File"
          />
        </StyledImageWrapper>
      </StyledFileBox>
    );
  };

export default FileAsImage;